import { Badge, Button } from "react-bootstrap";
import backBtn from "../../assets/icons/arrow_left.svg";
import { TransactionData } from "../../types";
import { formatAmount, formatDate, getStatusStyle } from "../../lib/utils";

interface TransactionRecordDetailsModalProps {
	transaction: TransactionData;
	onHide: () => void;
}

const safeJsonParse = (value: string | null | undefined) => {
	if (!value) return null;
	try {
		return JSON.parse(value);
	} catch {
		return null;
	}
};

const TransactionRecordDetailsModal = ({ transaction, onHide }: TransactionRecordDetailsModalProps) => {
	const formatJsonLike = (value: unknown) => {
		if (value === null || value === undefined) return "-";
		if (typeof value === "string") {
			const parsed = safeJsonParse(value);
			return parsed ? JSON.stringify(parsed, null, 2) : (value.trim() || "-");
		}
		if (typeof value === "object") return JSON.stringify(value, null, 2);
		return String(value);
	};

	const statusStyle = getStatusStyle(transaction.status || "");

	return (
		<>
			<div className="modal-backdrop" onClick={onHide}></div>
			<div className="modal-container">
				<div className="book-details-body">
					<div className="custom-modal-header">
						<div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "10px" }}>
							<img src={backBtn} alt="back" onClick={onHide} style={{ cursor: "pointer" }} />
							<h4>Transaction Details</h4>
						</div>
						<Button onClick={onHide}>Close</Button>
					</div>

					<div className="custom-modal-body">
						<div className="detail-section">
							<div className="book-id mb-4">
								<span style={{ fontWeight: "500" }}>Transaction ID</span>
								<span style={{ color: "#A5A5A5" }}>{`#${transaction.id}`}</span>
							</div>

							<div className="book-detail">
								<span>Status</span>
								<p>
									<Badge bg={statusStyle.variant} className={statusStyle.className}>
										{statusStyle.text}
									</Badge>
								</p>
							</div>

							<div className="book-detail">
								<span>Amount</span>
								<p>{formatAmount(transaction.amount)}</p>
							</div>

							<div className="book-detail">
								<span>Channel</span>
								<p>{transaction.channel ?? "-"}</p>
							</div>

							<div className="book-detail">
								<span>Product</span>
								<p>{transaction.product ?? "-"}</p>
							</div>

							<div className="book-detail">
								<span>Provider</span>
								<p>{transaction.provider ?? "-"}</p>
							</div>

							<div className="book-detail">
								<span>Type</span>
								<p>{transaction.type ?? "-"}</p>
							</div>

							<div className="book-detail">
								<span>Reference</span>
								<p>{transaction.reference ?? "-"}</p>
							</div>

							<div className="book-detail">
								<span>Account Name</span>
								<p>{transaction.account_name ?? "-"}</p>
							</div>

							<div className="book-detail">
								<span>Account Number</span>
								<p>{transaction.account_number ?? "-"}</p>
							</div>

							<div className="book-detail">
								<span>Bank</span>
								<p>{transaction.bank_name ?? "-"}</p>
							</div>

							<div className="book-detail">
								<span>Narration</span>
								<p>{transaction.narration ?? "-"}</p>
							</div>

							<div className="book-detail">
								<span>Description</span>
								<p>{transaction.description ?? "-"}</p>
							</div>

							<div className="book-detail mb-0">
								<span>Date</span>
								<p>{transaction.updated_at ? formatDate(transaction.updated_at) : "-"}</p>
							</div>
						</div>

						<div className="detail-section">
							<div className="book-detail">
								<span>User</span>
								<p>
									{transaction.user
										? `${transaction.user.first_name ?? ""} ${transaction.user.last_name ?? ""}`.trim() || "-"
										: "-"}
								</p>
							</div>
							<div className="book-detail">
								<span>Email</span>
								<p>{transaction.user?.email ?? "-"}</p>
							</div>
							<div className="book-detail mb-0">
								<span>Phone Number</span>
								<p>{transaction.user?.phone_number ?? "-"}</p>
							</div>
						</div>

						<div className="detail-section">
							<div className="book-detail">
								<span>Provider Response (JSON)</span>
								<pre className="json-box">
									{formatJsonLike(transaction.response)}
								</pre>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default TransactionRecordDetailsModal;


